import { HeaderComponent } from "./component/HeaderComponent";
import { withHeaderFooter } from "./HOC/withHeaderFooter";
import { withScroll } from "./HOC/withScroll";
import AppRoutes from "./Routes";

function App() {
  return (
    <>
      <div>
        <HeaderComponent />
      </div>
      <div>
        <AppRoutes />
      </div>
    </>
  );
}

export default withScroll(App);
